import React from 'react';
import ProTypes from 'prop-types';


export default function GlobalMobileMenuCloseButton({
  closeMenu
}) {
  return (
    <button
      className="GlobalMobileMenuCloseButton no-select purple f9 fw-light"
      onClick={ closeMenu }
      type="button"
    >
      { /* keep &times; to mimic mobile menu close button shape */ }
      &times;
    </button>
  );
}

GlobalMobileMenuCloseButton.propTypes = {
  closeMenu: ProTypes.func.isRequired
};
